import React, { Component } from "react"
import PropTypes from "prop-types"
import { loadMap } from "../../scripts/mapBox"

class MapBox extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    mapOptions: PropTypes.object,
    width: PropTypes.string,
    height: PropTypes.string,
    onMapLoaded: PropTypes.func
  }

  static defaultProps = {
    width: "100%",
    height: "100%",
    zoom: 15,
    mapOptions: {}
  }

  componentDidMount() {
    this.initMapBox()
  }

  componentWillUnmount() {
    if (this.mapbox) {
      this.mapbox.remove()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.id !== this.props.id) {
      this.initMapBox()
    }
  }

  withMapRef = () =>
    new Promise(resolve => {
      if (this.mapRef) resolve(this.mapRef)
      else {
        setTimeout(() => resolve(this.withMapRef()), 100)
      }
    })

  initMapBox = () => {
    this.withMapRef().then(mapRef => {
      const { mapOptions, zoom } = this.props
      return loadMap({ zoom, ...mapOptions, container: mapRef }).then(map => {
        this.mapbox = map
        if (this.props.onMapLoaded) {
          this.props.onMapLoaded(map)
        }
        return map
      })
    })
  }

  render() {
    const { width, height } = this.props
    return <div style={{ width, height }} ref={el => (this.mapRef = el)} />
  }
}

export default MapBox



// WEBPACK FOOTER //
// ./webapp/components/elements/MapBox.js